// extracted by css-extract-rspack-plugin
export default {"markdown":"markdown-KoCiE9"};